import { Link } from 'react-router-dom';
import { Clock, Crown, Check } from 'lucide-react';

export default function SubscriptionBanner({ user }) {
  const status = user?.subscription_status;
  const role = user?.role;

  // Admins never see banner
  if (role === 'admin') return null;

  // Active subscribers: green subtle bar
  if (status === 'active') {
    const plan = user?.subscription_plan;
    const endDate = user?.subscription_end_date;
    const formatted = endDate ? new Date(endDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '';

    return (
      <div className="bg-emerald-50 border-b border-emerald-200/50 px-4 py-2" data-testid="subscription-banner-active">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-2 text-xs text-emerald-700">
            <Check size={14} />
            <span className="font-medium capitalize">{plan} plan</span>
            {formatted && <span className="text-emerald-600/70">· renews {formatted}</span>}
          </div>
        </div>
      </div>
    );
  }

  // Trial: amber countdown bar
  if (status === 'trial') {
    const trialEnd = user?.trial_end_date;
    let daysLeft = 30;
    if (trialEnd) {
      try {
        const end = new Date(trialEnd);
        const now = new Date();
        daysLeft = Math.max(0, Math.ceil((end - now) / (1000 * 60 * 60 * 24)));
      } catch {}
    }

    return (
      <div className="bg-amber-50 border-b border-amber-200/50 px-4 py-2" data-testid="subscription-banner-trial">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-2 text-xs text-amber-800">
            <Clock size={14} />
            <span className="font-medium">Free trial</span>
            <span className="text-amber-600/80">· {daysLeft} day{daysLeft !== 1 ? 's' : ''} remaining</span>
          </div>
          <Link
            to="/pricing"
            className="text-[10px] uppercase tracking-wider font-semibold text-amber-700 hover:text-amber-900 transition-colors flex items-center gap-1"
            data-testid="trial-upgrade-link"
          >
            <Crown size={12} /> Upgrade
          </Link>
        </div>
      </div>
    );
  }

  // Expired: handled by SubscriptionWall, not banner
  return null;
}
